// Version utility - placeholders will be replaced during build
export const NILE_ELEMENTS_VERSION = '2.0.0';
export const NILE_VERSION = '1.2.8';

// Set global versions for runtime access
if (typeof window !== 'undefined') {
  (window as any).nileElementsVersion = NILE_ELEMENTS_VERSION;
  (window as any).nileVersion = NILE_VERSION;
  window.process = window.process || { env: { NODE_ENV: 'production' } };
}
